import { IEquipment } from '@/pages/Equipment/equipment.types'
import SeparateLine from '@/shared/Forms/SeparateLine'
import DropdownInput from '@/shared/Inputs/DropdownInput'
import Toggle from '@/shared/Inputs/Toggle'
import SidePage from '@/shared/SidePage'
import useEquipmentPassportVersionsHistory from './hooks/useEquipmentPassportVersionsHistory'
import EquipmentPassportVersionsСomparisonContent from './EquipmentPassportVersionsСomparisonContent'
import EquipmentPassportVersionsViewContent from './EquipmentPassportVersionsViewContent'
import ArrowRight from '@/assets/icons/arrowRightLine.svg?react'
import useEquipmentPassport from '@/pages/Equipment/hooks/useEquipmentPassport'
import Checkbox from '@/shared/Inputs/Checkbox'
import ThreeDotsLoader from '@/shared/Loaders/ThreeDotsLoader'
import Skeleton from '@/shared/Loaders/Skeleton'

interface IProps {
  onCancel: () => void
  open: boolean
  equipment: IEquipment
}

const EquipmentPassportVersionsHistorySidePage = (props: IProps) => {
  const { passport } = useEquipmentPassport(props.equipment?.passportInstanceId)
  const ctrl = useEquipmentPassportVersionsHistory({ passport })

  const renderDropdown = () => {
    if (ctrl.data.loading || !props.equipment) return <Skeleton height="var(--input-height)" width="100%" />
    if (ctrl.data.isVersionComparisonEnabled) {
      return (
        <div className="inline-flex-gap gap12 center">
          <DropdownInput
            wrapperStyle={{ width: '230px' }}
            options={ctrl.data.prevPassportVersionOptions}
            selectedOption={ctrl.data.selectedСomparableVersionIds['left']}
            title="Выберите версию паспорта"
            onSelect={ctrl.handlers.handleChangeSelecteСomparableVersionIds}
            name="left"
          />
          <ArrowRight height="16px" width="16px" />
          <DropdownInput
            wrapperStyle={{ width: '230px' }}
            options={ctrl.data.prevPassportVersionOptions}
            selectedOption={ctrl.data.selectedСomparableVersionIds['right']}
            title="Выберите версию паспорта"
            onSelect={ctrl.handlers.handleChangeSelecteСomparableVersionIds}
            name="right"
          />
        </div>
      )
    }
    return (
      <DropdownInput
        options={ctrl.data.prevPassportVersionOptions}
        selectedOption={ctrl.data.selectedVersionId}
        title="Выберите версию паспорта"
        onSelect={ctrl.handlers.handleSelectVersionId}
        name="lineMode"
      />
    )
  }

  const renderContent = () => {
    if (ctrl.data.loading || !props.equipment)
      return (
        <div className="flex-lines center height100 width100">
          <ThreeDotsLoader inscription="Загрузка..." />
        </div>
      )
    if (ctrl.data.isVersionComparisonEnabled)
      return (
        <EquipmentPassportVersionsСomparisonContent
          prevPassportVersionId={ctrl.data.selectedСomparableVersionIds['left']}
          passportVersionId={ctrl.data.selectedСomparableVersionIds['right']}
          equipment={props.equipment}
          isChangedOnly={ctrl.data.isChangedOnly}
        />
      )
    return (
      <EquipmentPassportVersionsViewContent
        equipment={props.equipment}
        equipmentPassportVersionId={ctrl.data.selectedVersionId}
      />
    )
  }

  return (
    <SidePage onClose={props.onCancel} open={props.open} size="large" style={{ paddingRight: 0 }}>
      <div className="flex-lines height100 gap16" style={{ scrollBehavior: 'smooth' }}>
        <div className="flex-lines gap16" style={{ paddingRight: '24px' }}>
          <h4 className="text-heading-4">История версий</h4>
          <SeparateLine />
          <div>
            <div className="flex-space-between">
              <div className="inline-flex-gap gap16 mt8">
                <Toggle
                  name="versionComparison"
                  checked={ctrl.data.isVersionComparisonEnabled}
                  onChange={() => ctrl.handlers.setIsVersionComparisonEnabled((prev) => !prev)}
                  size="large"
                />
                <p className="text-nm">Сравнение версий</p>
              </div>
              <div style={{ width: '510px' }}>{renderDropdown()}</div>
            </div>
          </div>
          <SeparateLine />
          {ctrl.data.isVersionComparisonEnabled && (
            <div style={{ alignSelf: 'end' }}>
              <Checkbox
                label="Отображать только измененные"
                name="isChangedOnly"
                onCheck={ctrl.handlers.handleChangeOnly}
                checked={ctrl.data.isChangedOnly}
              />
            </div>
          )}
        </div>
        {renderContent()}
      </div>
    </SidePage>
  )
}

export default EquipmentPassportVersionsHistorySidePage
